
export default {
    getAreaAtuacao(state) {
        return state.areaAtuacao
    },
    getAreasAtuacoes(state) {
        return state.areasAtuacoes
    }
}